    import Axios from 'axios'
    import Store from '@/store/index'
    import Tarea from '@/controlador/tarea'
    import Workarea from '@/controlador/workarea'
    import Router from '@/router'
    import Funciones from '@/funciones/index'

    const { checkrole, check_administrador } = Funciones

    const url_api = ()=>{ return Store.state.url_api }
    const token = ()=>{ return Store.state.token }
    const user = ()=>{ return Store.state.user }
    const work_area = ()=>{ return Store.state.workarea_actual }
    const proyecto_actual = ()=>{ return Store.state.proyecto_actual }
    const rol_actual = ()=>{ return Store.state.actual_rol }
    const login = ()=>{ return Store.state.login }

    const Aplicacion = {

        loading(boolean){ Store.commit('set_loading',boolean) },
        mini_loading(boolean){ Store.commit('set_miniloading',boolean) },

        notificar_realizado(string){

            var nlocal ={
                'run':true,
                'tipo':'realizado',
                'titulo':string,
                'contenido':'',
                'errores':[],
                'tiempo':5000,
                'cerrar':true
            }

            Store.commit('set_notificacion_local',nlocal)

        },

        notificar_advertencia(string){

            var nlocal ={
                'run':true,
                'tipo':'advertencia',
                'titulo':string,
                'contenido':'',
                'errores':[],
                'tiempo':6000,
                'cerrar':true
            }
    
            Store.commit('set_notificacion_local',nlocal)

        },

        async login(json){

            this.loading(true)

            await Axios.post(`${url_api()}login`,json,{'headers':{'content-type':'application/json'}})
            .then(response => {

                Store.commit('set_login',true)
                Store.commit('set_user',response.data.user)
                Store.commit('set_token',response.data.token)

                if(json.save_login == true){                    
                    localStorage.setItem('token',response.data.token)
                    localStorage.setItem('login','true')
                }

                setTimeout(()=>{
                    Router.push({'name':'Dashboard'})
                },300)

                this.loading(false)

            })
            .catch(error => {
                
                this.loading(false)

                if(error.response.data.error == 500){
                    var nlocal ={
                      'run':true,
                      'tipo':'alerta', 
                      'titulo':'Wrong password',
                      'contenido':'Retry again or restore password',
                      'errores':[],
                      'tiempo':5000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                }

                if(error.response.data.error == 600){
                    var nlocal ={
                      'run':true,
                      'tipo':'alerta', 
                      'titulo':'User not found',
                      'contenido':'Please set register',
                      'errores':[],
                      'tiempo':5000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                }

                if(error.response.data.error == 700){ this.dispatch('failrecap') }

            })
            .finally()
        },

        ////# login sobre otras plataformas #//        
        async login_social(json){

            await Axios.post(`${url_api()}login_social`,json,{'headers':{'content-type':'application/json'}})
            .then(response => {

                Store.commit('set_loginindex_start',{'user':response.data.user,'token':response.data.token,'areas':response.data.areas})

                if(json.save_login){
                    localStorage.setItem('token',response.data.token)
                    localStorage.setItem('login','true')
                }
                
                if(Router.currentRoute.name != 'Dashboard'){ Router.push({'name':'Dashboard'}) }

                this.loading(false)

            })
            .catch(error => {

                this.loading(false)

                if(error.response.data.errores == 600){
                    var nlocal ={
                      'run':true,
                      'tipo':'informativo', 
                      'titulo':'Usuario no encontrado!, ¿desea registrarse para continuar?',
                      'contenido':'',
                      'errores':[],
                      'tiempo':7000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                    Router.push({'name':'Registro'})
                }

                if(error.response.data.errores == 700){ Store.dispatch('failgtoken') }

            })
            .finally()

        },

        ///# llamar datos si ya esta logueado #//
        async si_login(){

            this.loading(true)
 
            await Axios.get(`${url_api()}index_user`,{'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response =>{

                Store.commit('set_login',true)
                Store.commit('set_user',response.data.user)

                setTimeout(()=>{
                    if(Router.currentRoute.name != 'Dashboard' ){ Router.push({'name':'Dashboard'}) }
                    this.loading(false)
                },500)


            })
            .catch(error =>{
                console.log(error)
                this.erase_registro()
            })
            .finally(()=>{
                
            })

        },

        //# comprobar el token de acceso de una secion previa #//
        si_token(){

            let bool_token = localStorage.getItem('token') ? true : false
           
            if(bool_token){

                Store.commit('set_token',localStorage.getItem('token'))
        
                setTimeout(()=>{ 
                
                    this.si_login()
                    
                },300)

            }
            else{
                if(Router.currentRoute.name == 'Dashboard'){ Router.push({'name':'Entrar'}) }
            }

        },
        
        //# logout #//
        async salir(){

            this.loading(true)

            await Axios.get(`${url_api()}logout`,{'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response => {
                this.erase_registro()
            })
            .catch(error => {
                console.log(error)
                Router.push({'name':'Entrar'})
            })
            .finally()

        },

        //# index comentarios home #//
        async index_comentarios(json){

            this.mini_loading(true)

            await Axios.get(`${url_api()}index_comentarios`,{'params':json,'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response=>{

                if(response.data.errores == 0){

                    if(json.recurso == 'reto'){ Store.dispatch('add_comts_retos',response.data.comentarios) }
                    if(json.recurso == 'idea'){ Store.dispatch('add_comts_ideas',response.data.comentarios) }
                    if(json.recurso == 'blog'){ Store.dispatch('add_comts_blogs',response.data.comentarios) }

                    this.mini_loading(false)

                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        },

        //# guardar evento sobre retos, tareas. blogs, proyectos #//
        async store_event(json){

            await Axios.put(`${url_api()}store_event`,json,{'headers':{'content-type':'application/json','Authorization': `Bearer ${token()}`}})
            .then(response => {
                Store.dispatch('realizado')
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            }).finally()

        },

        //# set seccion #//
        set_section_num(array){

            if(this.verificar_permisos_ruta(array[0])){ 
                Store.commit('set_seccion_num', array[0])
                Store.commit('set_seccion_head', array[1])
            }
            else{ 
                Store.dispatch('sin_permisos_noti') 
            }
            
        },

        //#  verificar permisos #//
        verificar_permisos_ruta(numero){

            let bool = false

            switch(numero){

                case 0: bool = checkrole('workarea','blog'); break; // vista de Blogs 
                case 2: bool = checkrole('proyectos','read'); break; //Ver Lista Proyectos
                case 3: bool = checkrole('horas','readmy'); break; // Mis Horas
                case 4: bool = checkrole('horas','readall'); break; // Horas registradas en Proyectos
                case 5: bool = checkrole('workarea','timesheet'); break; // Recursos Tiempos Personal
                case 6: bool = checkrole('workarea','permisos'); break; // Roles y Permisos
                case 9: bool = checkrole('proyectos','create'); break; // Crear Proyecto
                case 100: bool = checkrole('proyectos','archivo'); break; // Archivos
                case 101: bool = checkrole('balance','read'); break; // Reporte Proyecto
                case 102: bool = checkrole('proyectos','notify'); break; // Notificaciones
                case 103: bool = checkrole('personal','read'); break; // Personal en organización
                case 104: bool = checkrole('tareas','read'); break; // Lista Tareas
                case 105: bool = checkrole('gantt','read'); break; // Gantt Tareas
                case 106: bool = checkrole('tareas','kanban'); break; // Kanban
                case 107: bool = checkrole('compras','read'); break; // Compras
                case 108: bool = checkrole('gantc','read'); break; // Gantt Compras
                case 109: bool = checkrole('compras','readprov'); break; // Ver Proveedores
                case 110: bool = checkrole('proyectos','sharep'); break; // Compartir Proyecto
                case 111: bool = checkrole('proyectos','share'); break; // Compartir Proyecto URL
                case 112: bool = checkrole('proyectos','delete'); break; // Eliminar Proyecto
                case 113: bool = checkrole('compras','create'); break; // Crear Compra
                case 114: bool = checkrole('horas','regmy'); break; // Registrar Mis Horas
                case 115: bool = checkrole('horas','regall'); break; // Regisrar Horas a Todos
                case 116: bool = checkrole('personal','create'); break; // Registrar Personal
                case 117: bool = checkrole('compras','provee'); break; // Registrar Proveedor
                case 118: bool = checkrole('workarea','regalos'); break; // Ver Registrar Regalos
                case 16: bool = true; break; // Perfil
                case 97: bool = check_administrador(); break; // Usuarios Activos
                case 98: bool = checkrole('workarea','categories'); break; // Categorias
                case 99: bool = checkrole('workarea','puntosvalues'); break; // Puntos
                case 20: bool = true; break; // Lista Ideas
                case 27: bool = true; break; // Ver Idea
                case 22: bool = true; break; // Crear Idea
                case 23: bool = true; break; // Lista Retos
                case 26: bool = true; break; // Ver Reto
                case 25: bool = true; break; // Crear Reto
                case 28: bool = true; break; // Ver puntos
                case 29: bool = true; break; // Editar Reto
                case 30: bool = true; break; // Editar Idea
                case 50: bool = true; break; // Areas de trabajo
                case 51: bool = true; break; // Ver Idea Reto
                case 52: bool = true; break; // Editar Idea Reto

                default: bool = false; break;
            }

            return bool
        },

        //# toggle proyecto #//
        async toggle_proyecto(json){
        
            this.loading(true)

            await Store.dispatch('limpiar_area_proyecto')
            .then(response => {

                if(response == 0){

                    Store.commit('set_proyecto_actual',json)
                    Tarea.index({'proyecto_id':json.id,'recurso':'tareas','permisos':true})

                }

                if(response >= 1){ window.location.reload() }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally(()=>{ })

        },

        //# contacto #//
        async contacto_email(json){

            await Axios.post(`${url_api()}contact_email`,json,{'headers':{'content-type':'application/json'}})
            .then(response => {
                if(response.data.errores == 0){

                    var nlocal ={
                        'run':true,
                        'tipo':'informativo',
                        'titulo': 'Asakaa | Contacto',
                        'contenido':'Mensaje enviado!',
                        'errores':[],
                        'tiempo':7000,
                        'cerrar':true
                    }

                    this.loading(false)
                    Store.commit('set_notificacion_local',nlocal)
                }

                Router.push({'name':'Inicio'})
            })
            .catch(error => {
              console.log(error)
              window.location.reload()
            })
            .finally()
        },

        //# usuarios activos #//
        async index_active_users(){

            this.loading(true)

            await Axios.get(`${url_api() }active_users`,{'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response=>{

                Store.commit('set_active_users', response.data.active_users)
                Store.dispatch('realizado')
                
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        },
        
        //# cambair la contraseña sin login #//
        async recovery_pass(json){

            this.loading(true)

            await Axios.put(`${url_api()}recovery_pass`,json,{'headers':{'content-type':'application/json'}})
            .then(response => {
                
                this.loading(false)

                if(response.data.errores == 0){
                    
                    var nlocal ={
                        'run':true,
                        'tipo':'completado',
                        'titulo': 'Asakaa | Zona segura',
                        'contenido':'Se cambió la contraseña, puede iniciar sesión',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                
                }

                if(response.data.errores == 500){
                    var nlocal ={
                        'run':true,
                        'tipo':'alerta',
                        'titulo': 'Asakaa | Zona segura',
                        'contenido':'El usuario no existe!',
                        'errores':[],
                        'tiempo':6000,
                        'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                
                }

                if(response.data.errores == 400){
                    var nlocal ={
                        'run':true,
                        'tipo':'alerta',
                        'titulo': 'Asakaa | Zona segura',
                        'contenido':'Código Incorrecto',
                        'errores':[],
                        'tiempo':6000,
                        'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
                
                }

                if(response.data.errores == 300){
                    var nlocal ={
                        'run':true,
                        'tipo':'alerta',
                        'titulo': 'Asakaa | Zona segura',
                        'contenido':'Solicitud rechazada',
                        'errores':[],
                        'tiempo':6000,
                        'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)

                }

            })
            .catch(error => {
                if(error.response.data.error == 700){ this.dispatch('failrecap') }
            })
            .finally()
        },

        //# solicitud de cambio de contraseña sin login #//
        async restore_pass(json){

            this.loading(true)

            await Axios.put(`${url_api()}restore_pass`,json,{'headers':{'content-type':'application/json'}})
            .then(response => { 

                this.loading(false)

                if(response.data.errores == 200){

                    var nlocal ={
                      'run':true,
                      'tipo':'alerta', 
                      'titulo':json.email,
                      'contenido':'Solicitud rechazada!, el email no se encuentra registrado.',
                      'errores':[],
                      'tiempo':6000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)

                }

                if(response.data.errores == 300){

                    var nlocal ={
                      'run':true,
                      'tipo':'alerta', 
                      'titulo':json.email,
                      'contenido':'No fue posible enviar la notificación!, por favor intentelo mas tarde',
                      'errores':[],
                      'tiempo':10000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)

                }

                if(response.data.errores == 0){
                    var nlocal ={
                        'run':true,
                        'tipo':'realizado', 
                        'titulo':'Se envió una notificación al email '+json.email,
                        'contenido':'',
                        'errores':[],
                        'tiempo':6000,
                        'cerrar':false
                    }
  
                    Store.commit('set_notificacion_local',nlocal)
     
                }

            })
            .catch(error => {
                if(error.response.data.error == 700){ Store.dispatch('failrecap') }
            }).finally()

        },
        
        //# registro usuario nuevo #//
        async registrar_new(json){

            await Axios.post(`${url_api()}register`,json,{'headers':{'content-type':'application/json'}})
            .then(response=>{

                this.loading(false)

                if(response.data.errores == 300){
                    
                    var nlocal ={
                      'run':true,
                      'tipo':'advertencia', 
                      'titulo':'El usuario '+response.data.email+' ya se encuentra registrado',
                      'contenido':'Por favor inicie sesión o restablezca su contraseña',
                      'errores':[],
                      'tiempo':8000,
                      'cerrar':true
                    }

                    Store.commit('set_notificacion_local',nlocal)
                    
                }

                if(response.data.errores == 0){
                     
                    Store.commit('set_registro',{'user':response.data.user,'token':response.data.token})

                    if(json.save_login){
                        localStorage.setItem('token',response.data.token)
                        localStorage.setItem('login','true')
                    }

                    Router.push({'name':'Dashboard'})
                }


            })
            .catch(error => {
                console.log(error)
                if(error.response.data.errores == 700){ Store.dispatch('failrecap') }
            }).finally()

        },
        
        //# registro sobre otras plataformas #//
        async registrar_social(json){

            await Axios.post(`${url_api()}register_social`,json,{'headers':{'content-type':'application/json'}})
            .then(response=>{

                this.loading(false)
                
                if(response.data.errores == 0){

                    Store.commit('set_loginindex_start',{'user': response.data.user,'token': response.data.token,'areas':response.data.areas})
                    
                    if(json.save_login){
                        localStorage.setItem('token',response.data.token)
                        localStorage.setItem('login','true')
                    }

                    if(Router.currentRoute.name != 'Dashboard'){ Router.push({'name':'Dashboard'}) }
                }

            })
            .catch(error => {
                console.log(error)
                if(error.response.data.errores == 400){ window.location.reload() }
                if(error.response.data.errores == 700){ Store.dispatch('failgtoken') }
            }).finally()

        },

        //# consulta versiones de la plataforma #//
        async call_versions(){

            this.loading(true)

            await Axios.get(`${url_api()}versionlist`)
            .then(response => {
            
                if(response.data.cambios){

                   Store.commit('set_version_list',response.data.cambios )
                   Store.commit('set_version_backend',response.data.version )

                    var nlocal = {
                      'run': true,
                      'tipo': 'informativo',
                      'titulo': 'Asakaa | Versiones',
                      'contenido': '',
                      'errores': [],
                      'tiempo': 3000,
                      'cerrar': false
                    }

                    Store.commit('set_notificacion_local',nlocal)

                }

            }).catch(error => {

                console.log(error)

                var nlocal = {
                  'run': true,
                  'tipo': 'alerta',
                  'titulo': 'Asakaa | Versiones',
                  'contenido': 'Error!',
                  'errores': [],
                  'tiempo': 5000,
                  'cerrar': true
                }

                Store.commit('set_notificacion_local',nlocal)

            }).finally(()=>{ this.loading(false) } )

        },

        erase_registro(){
            Store.dispatch('cerrar_sesion')
            localStorage.removeItem('token')
            localStorage.removeItem('login')
        },

        async update_comentario(json){

            Aplicacion.mini_loading(true)

            await Axios.put(`${url_api()}update_comment`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response => {
                if(response.data.errores == 0){
                    Store.dispatch('realizado')
                }
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            }).finally()

        },

        async delete_comment(json){

            Aplicacion.loading(true)

            await Axios.put(`${url_api()}delete_comment`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response => {

                if(response.data.errores == 0){

                    if(json.recurso == 'reto'){
                        let cmts_r = Store.state.coms_retos

                        var cmts_mod_r = cmts_r.filter((c)=>{ return(c.id != json.id && c.parent_id != json.id) })

                        Store.commit('set_coms_retos', cmts_mod_r)
                    }

                    if(json.recurso == 'idea'){
                        let cmts_i = Store.state.coms_ideas
                        var cmts_mod_i = cmts_i.filter((c)=>{ return(c.id != json.id && c.parent_id != json.id) })
                        Store.commit('set_coms_ideas', cmts_mod_i)
                    }

                    if(json.recurso == 'blog'){
                        let cmts_b = Store.state.coms_blogs
                        var cmts_mod_b = cmts_b.filter((c)=>{ return(c.id != json.id && c.parent_id != json.id) })
                        Store.commit('set_coms_blogs', cmts_mod_b)
                    }

                    Store.dispatch('realizado')
                
                }
    
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            }).finally()

        },

    }

    export default Aplicacion